module.exports = __webpack_public_path__ + "img/logo-286x70.1addb6ca.svg";